import styles from './PaymentPage.module.scss'
import Title from '@/components/Typography/Title/Title'
import Text from '@/components/Typography/Text/Text'
import { TStageCost } from '@/store/slices/stagesSlice/interfaces'

export default function StageCost ({data}: {data: TStageCost}) {
  return (
    <div className={styles.rates}>
      <Title level={4} className={styles.rates_Title}>
        К оплате
      </Title>

      <div className={styles.stageCost}>
        <Text level={2}>
          Парковочные услуги
        </Text>
        <Text level={2}>
          {data.stage.amount}
        </Text>
      </div>

      {!!data.fines_amount && <div className={styles.stageCost}>
        <Text level={2}>
          Штраф на номер ТС
        </Text>
        <Text level={2}>
          {data.fines_amount}
        </Text>
      </div>}

    </div>
  )
}
